/**
 * @generated SignedSource<<62de7617bb67850c6cd35e9580da5fc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentPlusNewsAgendaRightContentContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetArticleTypeArticle" | "hooksPlusArticleLinkHandlerArticle" | "plusOpinionContentItemContent" | "plusPrimaryContentItemContent" | "plusSecondaryContentItemContent">;
  readonly " $fragmentType": "contentPlusNewsAgendaRightContentContent";
};
export type contentPlusNewsAgendaRightContentContent$key = {
  readonly " $data"?: contentPlusNewsAgendaRightContentContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentPlusNewsAgendaRightContentContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersGetArticleTypeArticle",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentPlusNewsAgendaRightContentContent",
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksPlusArticleLinkHandlerArticle",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckCanShowInPlusPlatformContent",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckArticleIsInSectionsArticle",
              "selections": (v3/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsPlusArticle",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PaywallType",
                      "kind": "LinkedField",
                      "name": "paywallTypes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityUuid",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsStyleArticle",
              "selections": (v3/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            (v2/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersUseContentSponsorContent",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topics",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sponsor",
                      "kind": "LinkedField",
                      "name": "sponsor",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sponsorTagSponsor"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sponsorType",
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersCheckIsMainTopicContent",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Topic",
                      "kind": "LinkedField",
                      "name": "topics",
                      "plural": true,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusOpinionContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusSecondaryContentItemContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "978895fa7f2c73eface76c679e7f155b";

export default node;
